import { accessTypeEnum } from './../../lib/enum';

export const addAccessRight = [
  accessTypeEnum.admin,
  accessTypeEnum.creatingMaintenances
];
export const editAccessRight = [
  ...addAccessRight,
  accessTypeEnum.approvingDefectiveStatements,
  accessTypeEnum.approvingDetailedDefectiveStatements,
  accessTypeEnum.approvingMaintenances
];
// согласование дефектной ведомости
export const canApprovingDefectiveStatements = [
  accessTypeEnum.admin,
  accessTypeEnum.approvingDefectiveStatements
];
// согласование детальной дефектной ведомости
export const canApprovingDetailedDefectiveStatements = [
  accessTypeEnum.admin,
  accessTypeEnum.approvingDetailedDefectiveStatements
];
// согласование карточки работ
export const canApprovingMaintenance = [
  accessTypeEnum.admin,
  accessTypeEnum.approvingMaintenances
];

export default {
  addAccessRight,
  editAccessRight,
  canApprovingDefectiveStatements,
  canApprovingDetailedDefectiveStatements,
  canApprovingMaintenance
};
